import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = { sendTo: String, transactionId: String, amount: Number, currency: String }

  // connect() runs again whenever Turbo replaces the body with a cached or restored copy of
  // this page, so the event carries the enquiry's transaction id for Google Ads to discard
  // the repeats rather than counting one enquiry several times.
  connect() {
    window.gtag("event", "conversion", {
      send_to: this.sendToValue,
      transaction_id: this.transactionIdValue,
      value: this.amountValue,
      currency: this.currencyValue
    })
  }
}
